import $ from 'jquery'
import Actor from './actor'
import guard from 'scoreboard/components/unsaved/guard'
import _ from 'lodash'
import Backbone from 'backbone'

/**
 * Goes to a particular page on the form
 */
class GoToPageActor extends Actor {

	act() {
		// If this is an embeddable resource, set the request uri so that it
		// uses the shared resource endpoint
		let token = _.get(this.options, 'formDirector.options.embeddedToken')
		let path = _.isNil(token) ? '' : `/shared/${token}`

		return new Promise((resolve, reject) => {
			guard.conditionallyRun(() => {
				let xhr = $.get({
					url: 'api/forms/' + this.options.action.goToPageFormId + path,
					success: function(data) {
						setNewPageData(this.model, data)

						// If the go-to-page actor is from a record list,
						// clear the current record because we are editing a new one
						if (this.options.action.recordListOrigin) {
							this.options.formDirector.setPreviousRecord(null)
						}
						this.options.formDirector.render({ initialRender: true })
						this.trigger('done')
						resolve()
					}.bind(this)
				})
				return xhr
			}, () => {
				// if the user decides to stay on the form from the guard
				this.options.formDirector.trigger('go-to-page', false)
				this.options.busyButton && this.options.busyButton.enable()
			})
		})
	}

}

const setNewPageData = (model, data) => {
	// retain the original label, not the page label
	data.label = model.get('label')
	model.reset(data)
	// #55810
	// model.reset eliminates treeItemsById, so we need to set it manually
	Backbone.trigger('load:dataset-tree-items', data.treeItems)
	model.setup()
}

_.extend(GoToPageActor.prototype, Backbone.Events)

export default GoToPageActor
export { setNewPageData }

GoToPageActor.__filename__ = 'forms/actions/go-to-page-actor.js'
